// @flow
import { openDialog } from '../../../../../react/features/base/dialog/actions';
import { translate } from '../../../../../react/features/base/i18n/functions';
import Dialog from '../../../../../react/features/base/ui/components/web/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import RecordingsList from './RecordingsList';

type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Dispatch<any>,

    filename: string,

    path: string
}

class ConfirmDialog extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);
    }

    _onSubmit = () => {
        APP.WildixAPI.Recording.deleteRecord(this.props.path).then(() => {
            this._onCancel();
        })
        .catch(() => {
            this._onCancel();
        });
    };

    _onCancel = () => {
        this.props.dispatch(openDialog(RecordingsList));
    };

    render() {
        const { filename, t } = this.props;

        return (
            <Dialog titleKey={`${t('strings.DeleteRecording')} "${filename}"`}
                okKey='dialog.confirmYes'
                cancelKey='dialog.Cancel'
                onCancel={this._onCancel}
                onSubmit={this._onSubmit}
                width={'small'}>
                {t('strings.AreYouSure')}
            </Dialog>
        );
    }
}

export default translate(connect(null, null)(ConfirmDialog));
